export const iconFontAwesomeAccessibilityAudioDescription = (
	<i className="fa-solid fa-audio-description"></i>
);
